import { Navbar, Footer } from "@/components/landing";
import { WorkIndex } from "@/components/work/WorkIndex";

export function WorkPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <div className="h-24 lg:h-28" aria-hidden="true" />
        <WorkIndex />
      </main>
      <Footer />
    </div>
  );
}
